export default __webpack_public_path__ + "img/6c348becbc92c235459c4213fc91424d.svg";